import { css } from "@emotion/css"

import { formatYearMonthDayHourMinute, getDayOfWeek } from "@p-ban/common/src/utils/DateUtils"

import COLOR_CODE from "../../../constant/color"

type Props = {
  date?: Date
  orderLimit?: Date | null
}

const ArrivalDate = ({ date, orderLimit }: Props) => {
  const year = date ? date.getFullYear() : "-"
  const month = date ? date.getMonth() + 1 : "-"
  const day = date ? date.getDate() : "-"
  const dayOfWeek = date ? getDayOfWeek(date) : "-"
  const dateTime = date?.toISOString()

  const content = (
    <>
      <span>{year}</span>年<span>{month}</span>月<span>{day}</span>日（{dayOfWeek}）
    </>
  )

  return (
    <>
      {orderLimit && (
        <div className={styles.orderLimitMessage}>
          {formatYearMonthDayHourMinute(orderLimit)} までにご注文いただいた場合
        </div>
      )}
      <div className={styles.arrivalDate}>
        お届け予定日：
        {dateTime ? <time dateTime={dateTime}>{content}</time> : content}
      </div>
    </>
  )
}

export default ArrivalDate

const styles = {
  orderLimitMessage: css`
    font-size: 11px;
    line-height: 1;
    color: ${COLOR_CODE.LIGHT_BLACK2};
    text-align: center;
    white-space: nowrap;
  `,
  arrivalDate: css`
    padding: 4px 0;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: bold;
    font-feature-settings: "palt";
    line-height: 1;
    color: ${COLOR_CODE.LIGHT_BLACK2};
    text-align: center;
    span {
      font-size: 15px;
    }
  `,
}
